import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';

function Form() {

    const session = getUserSession();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    if (profileFilter.pdc_project_ids) {
        hiddenValues.pdc_project_ids = profileFilter.pdc_project_ids
    }

    const path = '/cbosynonymousdescriptions/';
    const paths = {
        endpointSave: config.endpoints.backend + 'cbosynonymousdescriptions/save',
        endpointGetById: config.endpoints.backend + 'cbosynonymousdescriptions/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllSynonyms: config.endpoints.backend + 'cbosynonyms/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Vínculo CBO - Descrição",
        labelTitleEdit: "Editar Vínculo CBO - Descrição",
        labelTitleView: 'Visualizar Vínculo CBO - Descrição'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.projects = [{ project: '' }]
                        form.fields[2].autoFocus = true;
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'projects',
                    type: 'multiinput',
                    label: 'Projetos',
                    sortBy: 'index',
                    showDeleteButton: true,
                    form: [
                        {
                            name: 'pdc_project_id',
                            type: 'select',
                            label: 'Projeto',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllProjects,
                                label: 'project_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...hiddenValues,
                                        pdc_entity_id: hiddenValues.pdc_entity_id || values.pdc_entity_id ? !hiddenValues.pdc_entity_id ? values.pdc_entity_id : hiddenValues.pdc_entity_id : "none"
                                    }
                                }
                            },
                            validations: {
                                required: false
                            }
                        },
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_cbo_synonymous_id',
                    type: 'select',
                    label: 'CBO - Sinônimo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllSynonyms,
                        label: 'title',
                        value: 'id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
